import { createFeatureSelector, createSelector } from '@ngrx/store';
import { STANDBY_CANCEL_RESULT_STORE_NAME, StandbyCancelResultState } from './standby-cancel-result.state';

/** Select StandbyCancelResult State */
export const selectStandbyCancelResultState = createFeatureSelector<StandbyCancelResultState>(
  STANDBY_CANCEL_RESULT_STORE_NAME
);

/** Select StandbyCancelResult isPending status */
export const selectStandbyCancelResultIsPendingStatus = createSelector(
  selectStandbyCancelResultState,
  (state) => !!state.isPending
);

/** Select StandbyCancelResult isFailure status */
export const selectStandbyCancelResultIsFailureStatus = createSelector(
  selectStandbyCancelResultState,
  (state) => !!state.isFailure
);
